/**
 * Politique de mot de passe — point de centralisation unique côté frontend.
 *
 * PROD1.4.8 #529 : tous les inputs/forms de mot de passe utilisent ce
 * module. Pour durcir la politique (longueur, complexité, ...), modifier
 * UNIQUEMENT ce fichier.
 *
 * Doit rester aligné avec `backend/app/core/password_policy.py`.
 */

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_LABEL_SUFFIX = `(min. ${PASSWORD_MIN_LENGTH} caractères)`;

/**
 * Valide un mot de passe candidat. Retourne `null` si OK, sinon un
 * message d'erreur localisé adapté à l'affichage UI.
 */
export function validatePassword(value: string): string | null {
  if (value.length < PASSWORD_MIN_LENGTH) {
    return `Le mot de passe doit comporter au moins ${PASSWORD_MIN_LENGTH} caractères`;
  }
  return null;
}

export function isValidPassword(value: string): boolean {
  return validatePassword(value) === null;
}
